import { render, staticRenderFns } from "./precificacao.vue?vue&type=template&id=3faa79ca"
import script from "./precificacao.vue?vue&type=script&lang=js"
export * from "./precificacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports